import React from 'react';
import Header from './Componets/Header/Header';
import Appbody from './Componets/Appbody/Appbody';
import './App.css';

function App() {
  return (
    <div className="app">
      <Header></Header>
      <Appbody></Appbody>
    </div>
  );
}

export default App;
